import { createContext, useContext } from 'react';

import { StringWrapperCtor } from './types';

export interface TranslationsOptions {
  useLoader?<T>(from: StringWrapperCtor<T>): T;
}

export const defaultOptions: TranslationsOptions = {
  useLoader: undefined,
};
const TranslationsContext = createContext(defaultOptions);
export const TranslationsContextProvider = TranslationsContext.Provider;

export type UseTranslationsOptions = () => TranslationsOptions;
export const useTranslationsOptions: UseTranslationsOptions = () => useContext(TranslationsContext);
